document.addEventListener("DOMContentLoaded", function() {
    // Function to submit mobile filter form on resource change
    function submitMobileFilter() {
        if( document.getElementById("resource-filter-normal") ) {
            document.getElementById("resource-filter-mobile").submit();
        }
    }

    // Function to submit normal filter form on resource change
    function submitNormalFilter() {
        if( document.getElementById("resource-filter-normal") ) {
            document.getElementById("resource-filter-normal").submit();
        }
    }

    // Event listener for resource change in mobile filter
    document.addEventListener("change", function(event) {
        if (event.target.classList.contains("resource")) {
            submitMobileFilter();
        }
    });

    // Event listener for resource change in normal filter
    document.addEventListener("change", function(event) {
        if (event.target.classList.contains("normal")) {
            submitNormalFilter();
        }
    });

    // Function to disable scrollbar when filter is open in mobile view
    function disableScroll() {
        // Event listener to add 'open' class to body on filter button click
        document.querySelectorAll(".filter button").forEach(function(button) {
            button.addEventListener("click", function(event) {
                event.preventDefault();
                document.body.classList.add("open");
            });
        });

        // Event listener to remove 'open' class from body on offcanvas header button click
        document.querySelectorAll(".offcanvas-header button").forEach(function(button) {
            button.addEventListener("click", function(event) {
                event.preventDefault();
                document.body.classList.remove("open");
            });
        });
    }

    // Call disableScroll function
    disableScroll();

    // Event listener to remove 'open' class from body on click outside of offcanvas
    document.addEventListener("click", function(event) {
        if (!event.target.closest(".offcanvas")) {
            document.body.classList.remove("open");
        }
    });
});